/* Jquery match height */
$('.footer-list').matchHeight();
$('.block-carousel .content').matchHeight();
